import { gql } from "@apollo/client";

export const READ_APNS_PUSH_CENTERS_NAME = "GetAPNSPushCenters";
export const READ_APNS_PUSH_CENTERS_QUERY = gql`
query ${READ_APNS_PUSH_CENTERS_NAME}(
  $name_filter: String
  $first: Int = 15
  $cursor: String
  ) {
  fcm_apns_centers {
    apns(first: $first, after: $cursor, name__icontains: $name_filter) {
      edges {
      node {
        description
        file
        id_center
        name
        type
        certificates {
          meta
          type
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    }
  }
}
`;

export const READ_FCM_PUSH_CENTERS_NAME = "GetFCMPushCenters";
export const READ_FCM_PUSH_CENTERS_QUERY = gql`
query ${READ_FCM_PUSH_CENTERS_NAME}(
  $name_filter: String
  $first: Int = 15
  $cursor: String
  ) {
  fcm_apns_centers {
    fcm(first: $first, after: $cursor, name__icontains: $name_filter) {
    edges {
      node {
        description
        file
        id_center
        name
        type
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    }
  }
}
`;

export const GET_ASSIGNED_ACCOUNTS_TO_APNS_PUSH_CENTERS_QUERY_NAME =
  "GetApnsAssignedAccounts";
export const GET_ASSIGNED_ACCOUNTS_TO_APNS_PUSH_CENTERS_QUERY = gql`
  query ${GET_ASSIGNED_ACCOUNTS_TO_APNS_PUSH_CENTERS_QUERY_NAME}(
    $id_center: Decimal
    $cursor: String
    $first: Int = 25
    $name: String
  ) {
    fcm_apns_centers {
      apns(id_center: $id_center) {
        edges {
          node {
            assignment {
              id_ipmp
            }
            id_center
            name
            type
          }
        }
      }
    }
    ipmp_accounts(after: $cursor, first: $first, name__icontains: $name) {
      edges {
        node {
          name
          description
          enabled
          id_ipmp
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_ASSIGNED_ACCOUNTS_TO_FCM_PUSH_CENTERS_QUERY_NAME =
  "GetFcmAssignedAccounts";
export const GET_ASSIGNED_ACCOUNTS_TO_FCM_PUSH_CENTERS_QUERY = gql`
  query ${GET_ASSIGNED_ACCOUNTS_TO_FCM_PUSH_CENTERS_QUERY_NAME}(
    $id_center: Decimal
    $cursor: String
    $first: Int = 25
    $name: String
  ) {
    fcm_apns_centers {
      fcm(id_center: $id_center) {
        edges {
          node {
            assignment {
              id_ipmp
            }
            id_center
            name
            type
          }
        }
      }
    }
    ipmp_accounts(after: $cursor, first: $first, name__icontains: $name) {
      edges {
        node {
          name
          description
          enabled
          id_ipmp
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const CREATE_APNS_CENTER_MUTATION = gql`
  mutation CreateAPNSCenter($description: String!, $name: String!) {
    create_apns_center(description: $description, name: $name) {
      success
      message
    }
  }
`;

export const DELETE_APNS_CENTER_MUTATION = gql`
  mutation DeleteAPNSCenter($ids: [Int!]!) {
    delete_apns_center(id_center: $ids) {
      success
      message
    }
  }
`;

export const DELETE_APNS_CENTER_FILE_MUTATION = gql`
  mutation DeleteAPNSCenterFile($pairs: PairsEnum!, $ids: Int!) {
    delete_apns_files(id_center: $ids, pairs: $pairs) {
      success
      message
    }
  }
`;

export const CREATE_FCM_CENTER_MUTATION = gql`
  mutation CreateFCMCenter($description: String!, $name: String!) {
    create_fcm_center(description: $description, name: $name) {
      success
      message
    }
  }
`;

export const DELETE_FCM_CENTER_MUTATION = gql`
  mutation DeleteFCMCenter($ids: [Int!]!) {
    delete_fcm_center(id_center: $ids) {
      success
      message
    }
  }
`;

export const DELETE_FCM_CENTER_FILE_MUTATION = gql`
  mutation DeleteFCMCenterFile($ids: [Int!]!) {
    delete_fcm_file(id_center: $ids) {
      success
      message
    }
  }
`;
